//import Moment from "moment";

const getCount = (state) => {
	return state.pedidosAvulso.length;
}

const ultimaAtualizacaoListaPedidoAvulso = (state) => {
	if (state.ultimaAtualizacaoListaPedidoAvulso == null) {
		return true;
	}
	else if(!state.pedidosAvulso)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.pedidosAvulso.length == 0 ||
			hour - state.ultimaAtualizacaoListaPedidoAvulso.getHours() > 0
		);
	}
}

export default {
	getCount,
	ultimaAtualizacaoListaPedidoAvulso
}